import axiosInstance from "./axiosInstance";

export function create(param) {
  return axiosInstance.post('aboutUs/add',param)
}

export function update(param) {
  return axiosInstance.post('aboutUs/edit',param)
}

export function del(param) {
	return axiosInstance.post('aboutUs/del', param)
}

export function query(param) {
  return axiosInstance.post('aboutUs/query',param)
}

export function queryNext(param) {
  return axiosInstance.post('aboutUs/queryNext',param)
}

export function upload(formData) {
	return axiosInstance.post('file/obsUploadFile', formData)
}

export function queryAboutUs(param) {
  return axiosInstance.post('aboutUs/query',param)
}